$(document).ready(function () {

    $('.js-slideshow').each(function () {

        var slideshow = $(this);
        var active = true;

        if (slideshow.hasClass('js-slideshow--mobile-only')) {
            if ($(window).width() <= 1050) {
                active = true;
            } else {
                active = false;
            }
        }

        var slides = slideshow.find('.js-slide');
        var outer = slideshow.closest('.js-slideshow-outer');
        var pager = outer.find('.js-slideshow-pager');
        var next = outer.find('.js-next');
        var prev = outer.find('.js-prev');

        if (active) {
            $(this).initCycle({
                'slides': slides,
                'pager': pager,
                'pagerTemplate': '<div class="testimonials-dots"></div>',
                'pagerActiveClass': 'testimonials-dots--active',
                'next': next,
                'prev': prev,
                'fx': 'fade'
            });
        }

    });

    $('.js-slideshow').on('cycle-before', function () {
        $('.js-slideshow-content').fadeOut();
    }).on('cycle-after', function () {
        $('.js-slideshow-content').fadeIn();
    });

});